import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';
import User from 'src/modules/user/types/user';

@Component({
    selector: 'app-delete-account-confirm',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    standalone: false
})
export class DeleteAddressConfirm {
  public address: any;
  public userId: string;

  constructor(
    public dialogRef: MatDialogRef<DeleteAddressConfirm>,
    protected Api: ApiService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.address = data.address;
    this.userId = data.userId;
  }

  public async confirm() {
    const endpoint = `user-admin/${this.userId}/address/${this.address.id}`;
    const result = await this.Api.delete(endpoint, environment.userAdminUrl);
    this.dialogRef.close(result);
  }
}
